import { render, staticRenderFns } from "./ComplaintFollowUpForm.vue?vue&type=template&id=629a63b0&"
import script from "./ComplaintFollowUpForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports